<template>
  <div id="schedule">
    <div id="headNav">
      <div class="leftArrow" @click="goBack">
        <van-icon name="arrow-left"/>
      </div>
      <div class="title">{{$t('message.loan_record')}}</div>
      <div class="leftArrow"></div>
    </div>
    <van-notice-bar
      left-icon="volume-o"
      :text="$t('message.mar_tip')" style="top: 1.32rem;width: 100%;position: fixed;z-index:6"
    />
    <div style="">
      <van-tabs @click="onClick" color="#f3ce1f" v-model="actived" title-active-color="#f3ce1f" swipe-threshold="4">
        <van-tab :title="$t('message.sch_sh')">
          <div style="margin-top: 1.5rem">
            <div class="list_items" v-for="(item,index) in detail_list" :key="index">
              <div class="list_items_time">
                <div style="color: #000000;font-size: 0.48rem;font-weight: 600">
                  <span class="sep"></span>{{item.company}}
                </div>
                <span style="color: #FBC42F;font-size: 0.32rem">{{$t('message.sch_shz')}}</span>
              </div>
              <div class="list_items_content">
                <div class="list_items_content_left">
                  <div><img :src="item.company_url" alt=""
                            style="width: 1.33rem;height: 1.33rem;margin-right: 10px;border-radius: 8px">
                  </div>
                  <div>
                    <div style="color: #000000;font-size: 0.48rem;font-weight: 500">
                      {{add_comma_toThousands(item.loan_amount)}}{{coin}}
                    </div>
                    <div style="color: #929191;font-size: 0.25rem;margin-top: 0.44rem">{{item.loan_order_time}}</div>
                  </div>
                </div>
                <div>
                  <van-button round type="primary" size="mini" @click="goviewSchdule(item)" class="holBtns">
                    {{$t('message.sch_ckjd')}}
                  </van-button>
                </div>
              </div>
            </div>

          </div>
        </van-tab>
        <van-tab :title="$t('message.sch_tx')">
          <div style="margin-top: 1.5rem">
            <div class="list_items" v-for="(item,index) in detail_list" :key="index">
              <div class="list_items_time">
                <div style="color: #000000;font-size: 0.48rem;font-weight: 600">
                  <span class="sep"></span>{{item.company}}
                </div>
                <van-tag type="primary">{{item.reback_day}} {{$t('message.tian')}}</van-tag>
              </div>
              <div class="list_items_content">
                <div class="list_items_content_left">
                  <div><img :src="item.company_url" alt=""
                            style="width: 1.33rem;height: 1.33rem;margin-right: 10px;border-radius: 8px">
                  </div>
                  <div>
                    <div style="color: #000000;font-size: 0.48rem;font-weight: 500">
                      {{add_comma_toThousands(item.loan_amount)}}{{coin}}
                    </div>
                    <div style="color: #929191;font-size: 0.25rem;margin-top: 0.44rem;" v-if="item.make_loan_time!=0">{{item.make_loan_time}}</div>
                  </div>
                </div>
                <div>
                  <van-button round type="primary" size="mini" @click="goWithdraw(item)" v-if="item.Agreed_status==0"
                              class="btns solidBtn">{{$t('message.sch_tx')}}
                  </van-button>
                  <van-button round color="rgb(245, 200, 38)" size="mini"  v-if="item.Agreed_status==1" class="btns solidBtn">
                    {{$t('message.sch_txz')}}
                  </van-button>
                </div>
              </div>
            </div>
            <div style="margin:1rem auto 0;width: 100%;position: fixed;bottom: 60px" v-if="show_borrow">
              <van-button block round @click="goLoan" class="btns" style=" color:#fff;width: 80%;margin: 0 auto">{{$t('message.borrow_lijk')}}</van-button>
            </div>
          </div>
        </van-tab>
        <van-tab :title="$t('message.sch_hk')">
          <div style="margin-top: 1.5rem">
            <div class="list_items" v-for="(item,index) in detail_list" :key="index">
              <div class="list_items_time">
                <div style="color: #000000;font-size: 0.48rem;font-weight: 600">
                  <span class="sep"></span>{{item.company}}
                </div>
                <!--                <span style="color: #08A367;font-size: 0.32rem">{{$t('message.sch_yfk')}}</span>-->
              </div>
              <div class="list_items_content">
                <div class="list_items_content_left">
                  <div><img :src="item.company_url" alt=""
                            style="width: 1.33rem;height: 1.33rem;margin-right: 10px;border-radius: 8px">
                  </div>
                  <div>
                    <div style="color: #000000;font-size: 0.48rem;font-weight: 500">
                      {{add_comma_toThousands(item.loan_amount)}}{{coin}}
                    </div>
                    <div style="color: #929191;font-size: 0.25rem;margin-top: 0.44rem">{{item.reback_date}}</div>
                  </div>
                </div>
                <div>
                  <van-button round type="primary" size="mini" @click="goRepay(item)" class="solidBtn">
                    {{$t('message.sch_hk')}}
                  </van-button>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab :title="$t('message.sch_ywc')">
          <div style="margin-top: 1.5rem">
            <div class="list_items" v-for="(item,index) in detail_list" :key="index">
              <div class="list_items_time">
                <div style="color: #000000;font-size: 0.48rem;font-weight: 600">
                  <span class="sep"></span>{{item.company}}
                </div>
                <div>
                  <span v-if="item.verify_status==3||item.make_loan_status==5||item.make_loan_status==6" style="color: red;font-size: 0.32rem">{{$t('message.sch_yjj')}}</span>
                  <span v-if="item.make_loan_status==2" style="color: #08A367;font-size: 0.32rem">{{$t('message.sch_ywc')}}</span>
                </div>

              </div>
              <div class="list_items_content">
                <div class="list_items_content_left">
                  <div><img :src="item.company_url" alt=""
                            style="width: 1.33rem;height: 1.33rem;margin-right: 10px;border-radius: 8px">
                  </div>
                  <div>
                    <div style="color: #000000;font-size: 0.48rem;font-weight: 500">
                      {{add_comma_toThousands(item.loan_amount)}}{{coin}}
                    </div>
                    <div style="color: #929191;font-size: 0.25rem;margin-top: 0.44rem">{{item.loan_order_time}}</div>
                  </div>
                </div>
                <div>
                  <!--已完成订单列表 type==4   需判断 to_borrow 字段   to_borrow = 0 展示操作按钮  ==1 不展示操作按钮  其他列表不需要判断 is_close=1的时候是订单关闭，不展示按钮-->
                  <van-button round type="primary" size="mini" @click="goLoanMount(item)"
                              v-if="(item.is_close)!=1&&(item.to_borrow==0&&(item.repayment_status ==2  || item.make_loan_status==5 || item.make_loan_status==6))"
                              class="solidBtn">
                    {{$t('message.sch_cxjk')}}
                  </van-button>
                  <van-button round type="primary" size="mini" @click="goRestRZ(item)"
                              v-if="(item.to_borrow==0&&item.verify_status==3)" class="solidBtn">
                    {{$t('message.sch_cxjk')}}
                  </van-button>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab :title="$t('message.btn_info_44')">
          <div style="margin-top: 1.5rem">
            <div class="list_items" v-for="(item,index) in detail_list" :key="index">
              <div class="list_items_time">
                <div style="color: #000000;font-size: 0.48rem;font-weight: 600">
                  <span class="sep"></span>{{item.company}}
                </div>
<!--                <span style="color: #FBC42F;font-size: 0.32rem">{{$t('message.sh_refuse')}}</span>-->
              </div>
              <div class="list_items_content">
                <div class="list_items_content_left">
                  <div><img :src="item.company_url" alt=""
                            style="width: 1.33rem;height: 1.33rem;margin-right: 10px;border-radius: 8px">
                  </div>
                  <div>
                    <div style="color: #000000;font-size: 0.48rem;font-weight: 500">
                      {{add_comma_toThousands(item.loan_amount)}}{{coin}}
                    </div>
                    <div style="color: #929191;font-size: 0.25rem;margin-top: 0.44rem">{{item.loan_order_time}}</div>
                  </div>
                </div>
                <div>

                </div>
              </div>
            </div>

          </div>
        </van-tab>
      </van-tabs>
      <div v-if="detail_list.length==0" class="no_data">
        <img src="../../../assets/images/3x/nodata.png" alt="">
      </div>
    </div>

  </div>
</template>

<script>
  import {getLoanProgress, getBorrowlist, sassDetailRec,sassIndex} from '../../../ports/port'
  import headNav from "../../HeadNav/headNav";

  export default {
    name: "schedule",
    data() {
      return {
        actived: 0,//已经通过的长度
        textTitle: '',
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        isOrder: JSON.parse(sessionStorage.getItem('indexJH')),//获取是否有订单
        current_index: 1,
        detail_list: [],
        coin:this.$coin,
        show_borrow:false
      }
    },
    components: {
      headNav
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      if (this.$route.query.index == undefined) {
        this.current_index = 1;
        this.actived = 0;
        sassDetailRec({userid: this.tk.userid, type: this.current_index})
          .then(res => {
            this.detail_list = [];
            if (res.data.code == 200) {
              this.detail_list = res.data.data.map((elem, index) => {
                elem.loan_order_time = this.transDate(elem.loan_order_time);
                elem.reback_date = this.transDate(elem.reback_date);
                elem.make_loan_time = elem.make_loan_time==0?0:this.transDate(elem.make_loan_time);
                return elem
              });
            } else {
              this.$notify({type: 'danger', message: res.data.msg});
            }
          })
          .catch(err => {
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      } else {
        this.current_index = Number(this.$route.query.index) + 1;
        this.actived = Number(this.$route.query.index);
        sassDetailRec({userid: this.tk.userid, type: this.current_index})
          .then(res => {
            this.detail_list = [];
            if (res.data.code == 200) {
              this.detail_list = res.data.data.map((elem, index) => {
                elem.loan_order_time = this.transDate(elem.loan_order_time);
                elem.reback_date = this.transDate(elem.reback_date);
                elem.make_loan_time = elem.make_loan_time==0?0:this.transDate(elem.make_loan_time);
                return elem
              });
            } else {
              this.$notify({type: 'danger', message: res.data.msg});
            }
          })
          .catch(err => {
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      }
      sassIndex({userid: this.tk.userid})
        .then(res => {
          if (res.data.code == 200) {
            if(res.data.data.base_info_varify==2&&res.data.data.sociel_varify==2&&res.data.data.xy_bank_verify==2&&res.data.data.yys_varify==2){
              if (res.data.data.is_order != 1) {
                this.show_borrow = true;
              }
            }
          } else {
            this.$notify({
              type: 'danger',
              message: res.data.msg
            });
          }
        });
    },
    mounted() {
      window.scrollTo(0, 0);
    },
    methods: {
      goLoan(){
        this.$router.push('/borrow')
      },
      onClick(name, title) {
        this.current_index = name + 1;
        this.detail_list = [];
        this.$router.push({path: '/schedule', query: {index: name}});
        this.actived = name;
        this.$store.commit('edit', true);//关闭全局的loading
        sassDetailRec({userid: this.tk.userid, type: this.current_index})
          .then(res => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (res.data.code == 200) {
              this.detail_list = res.data.data.map((elem, index) => {
                elem.loan_order_time = this.transDate(elem.loan_order_time);
                elem.reback_date = this.transDate(elem.reback_date);
                elem.make_loan_time = elem.make_loan_time==0?0:this.transDate(elem.make_loan_time);
                return elem
              });
            } else {
              this.$notify({type: 'danger', message: res.data.msg});
            }
          })
          .catch(err => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      },
      goWithdraw(a) {
        // sasstx({orderid:a.orderid})
        // .then(res=>{
        //   console.log(res);
        // })
        this.$router.push({path: '/schedule/withdraw', query: {orderid: a.orderid}});
      },
      goviewSchdule(a) {
        let data = JSON.stringify(a);
        this.$router.push({path: '/schedule/viewSchedule', query: {'data': data}});
      },
      goRepay(a) {
        this.$router.push({
          path: '/schedule/repay',
          query: {orderid: a.orderid}
        })//type=>3  代表待还款
      },
      //时间戳转为时间
      transDate(a) {
        const timer = Number(a + '000');
        const time = new Date(timer);
        const y = time.getFullYear();
        const m = time.getMonth() + 1;
        const d = time.getDate();
        const h = time.getHours();
        const mm = time.getMinutes();
        const s = time.getSeconds();
        return this.timeTrans(d) + '-' + this.timeTrans(m) + '-' + y + ' ' + this.timeTrans(h) + ':' + this.timeTrans(mm) + ':' + this.timeTrans(s)
      },
      timeTrans(m) {
        return m < 10 ? '0' + m : m
      },
      //重新认证
      goRestRZ(a) {
        this.$router.push({path: '/photos', query: {orderid: a.orderid}});
        sessionStorage.setItem('restRZ', '1');//如果审核拒绝，重新走一遍认证
      },
      goLoanMount(a) {
        this.$router.push({path: '/borrow', query: {orderid: a.orderid,'company_token':a.company_token}});
      },
      //金额格式转换
      add_comma_toThousands(num) {
        var num = (num || 0).toString();
        let inc = num.indexOf('.');
        if (inc == -1) {
        } else {
          num = num.substring(0, inc);
        }
        var result = '';
        while (num.length > 3) {
          result = ',' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
        }
        if (num) {
          result = num + result;
        }
        return result;
      },
      goBack() {
        this.$router.push('/home')
      }
    }
  }
</script>

<style scoped lang="scss">
  #schedule {
    background: #F8F8F8;
    min-height: 100vh;

    .list_items {
      background: #fff;
      border-bottom: 5px;
      border-radius: 10px;
      width: 95%;
      margin: 0 auto 8px;
      padding: 10px 15px;
      box-sizing: border-box;

      .list_items_time {
        border-bottom: 1px solid #ece7e7;
        padding: 5px 0;
        display: flex;
        align-content: center;
        justify-content: space-between;
      }

      .list_items_content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 10px;

        .list_items_content_left {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .van-button--mini {
    padding: 0 10px;
  }

  /deep/ .van-tabs--card > .van-tabs__wrap {
    margin-top: 10px;
  }

  .solidBtn {
    @include minBtns;
    background-color: $color;
  }

  .holBtns {
    @include minBtns;
    background-color: #fff;
    color: $color;
  }

  .sep {
    width: 3px;
    background: $color;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    margin-right: 5px;
    border-radius: 2px;
  }

  /deep/ .van-tab.van-tab--active {
    color: $color !important;
  }

  /deep/ .van-tabs__line {
    background-color: $color !important;
  }

  /deep/ .van-tabs__wrap {
    padding-top: 1.3rem;
    position: fixed;
    z-index: 1;
    width: 100%;
    top: 1.1rem!important;
    left: 0;
  }

  /deep/ .van-tabs__content {
    padding-top: 85px;
  }

  .no_data {
    min-height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 2.45rem;
    }
  }

  #headNav {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 5;
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding: 0 10px;
    height: 1.3rem;
    line-height: 1.3rem;
    background-color: #fff;
    border-bottom: 1px solid rgba(122, 122, 122, 0.1);

    .title {
      font-size: 18px;
      color: #262626;
      font-weight: 500;
    }

    .leftArrow {
      font-size: 18px;
      display: flex;
      align-items: center;
      width: 40px;
    }
  }
  .btns{
    background-color: $color;
    border-color: $color;
  }
  #btn{
    background-color: $color;
    border-color: $color;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/Audit/schedule.vue